var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFunnel = function SvgFunnel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 86 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.018 4.98C-.28 2.985 1.151.344 3.532.344h67.803c2.408 0 3.835 2.694 2.482 4.686L45.346 46.938A2 2 0 0 0 45 48.062v15.963a3 3 0 0 1-.971 2.21l-12.015 11.03c-1.283 1.178-3.353.269-3.353-1.472V48.04a2 2 0 0 0-.324-1.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.4,
    d: "M74.808 11.078a4 4 0 0 1 3.296-1.734H82a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-9.396c-3.22 0-5.12-3.612-3.296-6.266zm-14 20a4 4 0 0 1 3.296-1.734H82a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H58.604c-3.22 0-5.12-3.612-3.296-6.266z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 16,
    x: 50,
    y: 49.344,
    fill: "currentColor",
    fillOpacity: 0.4,
    rx: 4
  })));
};
export default SvgFunnel;